import { observer } from 'mobx-react-lite'
import { useLayoutEffect } from 'react'
import { Navigate, useLocation, useParams } from 'react-router-dom'

import { useAppStore } from '@src/app/context'
import { logError } from '@src/lib/log'

import { markExperimentFromReferral } from '@odyssey/feature-flags/experimentFromReferral'

const UniversalLoginCouponRoute = () => {
  const { couponId } = useParams()
  const location = useLocation()
  const store = useAppStore()

  useLayoutEffect(() => {
    if (couponId) {
      // FIXME(UXP-5129): mark the request as anonymous since we are fetching without auth
      void (async () => {
        try {
          await store.service.billing.fetchCoupon(couponId)
          markExperimentFromReferral()
        } catch (e) {
          logError(e)
        }
      })()
    }
  }, [couponId, store.service.billing, store.service.billing.fetchCoupon])

  return <Navigate to={{ pathname: '/signup', search: location.search }} />
}

export default observer(UniversalLoginCouponRoute)
